
<ng-container *ngIf = "false && DevMode">
    
    <div class="DevMode_box">
        <div class="DevIcon">
            
        </div>
        <div class="DevMode">
        <span class="pole_devK">
            <span class="opis_k">Typ kontrolki</span>
            <span class="wartosc_k">{{control.ControlType}}</span>
        </span>
        <span class="pole_devK">
            <span class="opis_k">Nazwa kontrolki</span>
            <span class="wartosc_k">{{control.KeyName}}</span>
        </span>
        <span class="pole_devK">
            <span class="opis_k">Szerokość / 12</span>
            <span class="wartosc_k"><input type ="text" [(ngModel)]="this.control.Width"></span>
        </span>
        <span class="pole_devK">
            <span class="opis_k">Ilość lini</span>
            <span class="wartosc_k"><input type ="text" [(ngModel)]="this.control.Row"></span>
        </span>
        <span class="pole_devK">
            <span class="wartosc_k" (click) = "otworzDev()"><div class="info_dev"></div></span>
            <span class="pole_kontrolka_dev">
                
                
            </span>
        </span>
        <div class="wybierz_wartosc">
            <div class="wyboerz_wartosc_tresc">wybierz wartość:</div>
            <div class="opcje_Wartosci"> (<span *ngFor="let v of control.Values; let kk = index;" class="opcja" (click) = "zmienWartoscAdmin(v.Key, false)">{{v.Key}} - </span>)</div>
        </div>
    </div>
</div>
</ng-container>




<div class="ustawienie controlerror_{{control.bladKontrolki}}">
    <ng-container *ngIf = "ResizeMode || DevMode">
    
        <div class="Resize_box resize_{{control.ControlType}}">
            <div class="DevIcon Resize">
            </div>
            <div class="Resize_pole">
                <span class="pole_devK" *ngIf = "ResizeMode">
                    <span class="opis_k">Szerokość / 12</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="this.control.Width"></span>
                </span>
                <span class="pole_devK"  *ngIf = "ResizeMode">
                    <span class="opis_k">Ilość lini</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="this.control.Row"></span>
                </span>
                <span class="pole_devK">
                    <span class="opis_k">kolor</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="control.ForegrandColour"></span>
                </span>
                <span class="pole_devK">
                    <span class="opis_k">Tło</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="control.BackgroundColour"></span>
                </span>
                <span class="pole_devK">
                    <span class="opis_k">Akapit</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="control.Akapit"></span>
                </span>
                <span class="pole_devK">
                    <span class="opis_k">Wielkość</span>
                    <span class="wartosc_k"><input type ="text" [(ngModel)]="control.Size"></span>
                </span>
                <span class="pole_devK" *ngIf = "false">
                    <span class="opis_k">Ukryj</span>
                    <span class="wartosc_k"><input type ="checkbox" [(ngModel)]="this.control.Hide"></span>
                </span>
                <div class="nazwa_k">{{control.KeyName}} <span class="wartosc_k2" (click) = "otworzDev()"><div class="info_dev"></div></span></div>
                 <ng-container *ngIf = "DevMode">
                    <span class="Wartosc_akt">wartość: {{control.wybrany.Value}} Wyświetla: {{control.wybrany.DisplayValue}}</span>
                    <input class ="Akapit_Info Akapit_{{control.Akapit}}"  name="parametr" (change) = "changeTextAdmin(control)" [disabled] = "CzyDisabled(i)"  [style.font-size.px]="control.Size"  [(ngModel)]="control.wybrany.Value"  [style.background-color]="control.BackgroundColour" [style.color]="control.ForegrandColour" >
                </ng-container>
            </div>
    </div>
    </ng-container>
    <span *ngIf = "control.bladKontrolki" id="nie_poprawna_kontrolka" [translation]="TranslationEnum.TranslationForm">{{'nie_poprawna_kontrolka'|translate}}</span>
    <ng-container *ngIf = "!this.control.Hide">
        <container-element [ngSwitch]="control.ControlType">
            <!-- the same view can be shown in more than one case -->
            <ng-container *ngSwitchCase="'NewLine'"><div class="NewLine"></div></ng-container>

            
            
            <ng-container *ngSwitchCase="'Label'">
                <div class="formatuj Label_box_o">
                    <div class="ng"><span class="Label_box">
                        <span  id="{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('' + control.TranslateCode.toLowerCase())|translate}}</span>
                        <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                    </span></div>
                    <div class="kon" class="Label Akapit_Info Akapit_{{control.Akapit}}"   [style.font-size.px]="control.Size"  [style.background-color]="control.BackgroundColour" [style.color]="control.ForegrandColour">
                        <div *ngIf="CzyLiczba(control.wybrany.DisplayValue)">{{control.wybrany.DisplayValue}}</div>
                        <div *ngIf="!CzyLiczba(control.wybrany.DisplayValue)"><span  id="{{control.TranslateCode.toLowerCase()}}_value" [translation]="TranslationEnum.TranslationForm">{{(control.TranslateCode.toLowerCase() + '_value')|translate}}</span></div>
                        <mat-icon  class="icon-label" color="accent">
                            info_outline
                        </mat-icon>
                    </div>
                </div>
                
                
            </ng-container>
            
            <ng-container *ngSwitchCase="'Info'">
                <span class = "Info Akapit_Info Akapit_{{control.Akapit}}" [style.font-size.px]="control.Size" [style.background-color]="control.BackgroundColour" [style.color]="control.ForegrandColour" [style.font.size] id="{{control.TranslateCode.toLowerCase()}}_value" [translation]="TranslationEnum.TranslationForm">{{(control.TranslateCode.toLowerCase() + '_value')|translate}}</span>
          
                
                
            </ng-container>
            <ng-container *ngSwitchCase="'Check'"><div class="Check poprawna{{control.poprawne}} Akapit_Grid  Akapit_{{control.Akapit}}" [style.background-color]="control.BackgroundColour">
                
                <input type = "checkbox" [(ngModel)]="checked" (change) = "changeCheck($event)" [disabled] = "CzyDisabled(i)"  [style.font-size.px]="control.Size">
                <span class="check_text"  [style.font-size.px]="control.Size" >
                    <span *ngIf = "control.poprawne" [style.color]="control.ForegrandColour"  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <span *ngIf = "!control.poprawne" id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                
                <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information></span>
              
                
            </div></ng-container>
            <ng-container *ngSwitchCase="'Usunieta'"></ng-container>

            
            <ng-container *ngSwitchCase="'Module'" ><div class="Module poprawna{{control.poprawne}}">
                <div class="ng"><span class="Label_box">
                    <span  id="{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span></div>

                    <div class="pola wyboru">
                        <div class="modul_wiersz" *ngFor="let kolumna of module.matrix; let x = index">
                            <ng-container *ngFor="let komorka of kolumna; let y = index">
                                <div *ngIf = "(komorka || module.czySasiad(x, y)) && CzyAktywny(i)" class="modul_komorka komorka_{{komorka}}" 
                                (click)="SetModule(y,x)">
                                    <span *ngIf="komorka">M{{module.getName(y,x)}} <span class="rodzaj_mod">({{module.getRodzaj(x, y)}})</span></span>
                                </div>
                                <div *ngIf = "(komorka || module.czySasiad(x, y)) && CzyDisabled(i)" class="modul_komorka komorka_{{komorka}}" >
                                    <span *ngIf="komorka">M{{module.getName(y,x)}} <span class="rodzaj_mod">({{module.getRodzaj(x, y)}})</span></span>
                                </div>
                                <div *ngIf = "!komorka && !module.czySasiad(x, y)" class="modul_komorka komorka_szara komorka_{{komorka}}">
                                    <span *ngIf="komorka"></span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    
                    <div class="wybrane_mod">wybrane moduły: {{module.getDisplay()}}</div>
                    <div class="wybrane_mod"> {{control.wybrany.Value}}</div>
                  
            </div></ng-container>












        
        <ng-container *ngSwitchCase="'Pergola'">
            <div class="pergola_out poprawna{{control.poprawne}} system_{{control.pergola.system}}">
                <div class="Pergola" id="Pergola{{control.pergola.random}}">
                    <div class="pergola_pole">
                        <div class="pergola_zew"  [style.width.px]="control.pergola.getWidth()"   [style.height.px]="control.pergola.getHeight()" >
                            <div class="sciany">
                                <div class="sciana scianaA" *ngIf = "control.pergola.scianaA"></div>
                                <div class="sciana scianaB" *ngIf = "control.pergola.scianaB"></div>
                                <div class="sciana scianaC" *ngIf = "control.pergola.scianaC"></div>
                                <div class="sciana scianaD" *ngIf = "control.pergola.scianaD"></div>
                            </div>
                            <div class="sciany">
                                <div class="pergola_obok scianaA" *ngIf = "control.pergola.pergolaA"></div>
                                <div class="pergola_obok scianaB" *ngIf = "control.pergola.pergolaB"></div>
                                <div class="pergola_obok scianaC" *ngIf = "control.pergola.pergolaC"></div>
                                <div class="pergola_obok scianaD" *ngIf = "control.pergola.pergolaD"></div>
                            </div>
                            <div class="wymiarx">
                                <div class="wymiarx2">
                                    <div class="wymiar">{{control.pergola.szerokosc}} mm</div>
                                </div>
                            </div>
                            <div class="wymiary">
                                <div class="wymiary2">
                                    <div class="wymiary2-2"  [style.bottom.px]="control.pergola.getLeft()">{{control.pergola.glebokosc}} mm</div>
                                </div>
                            </div>
                            <div class = "pole_slupy">
        

                                <ng-container *ngFor="let slup of control.pergola.slupy; let s = index;">

                                    <div class="slup blad_{{slup.blad || slup.blad_nachodzi || slup.bladWysokosc}}" *ngIf = "s > 3 && slup.czy_widoczny"  cdkDrag  cdkDragBoundary=".pergola_zew" [style.width.px]="slup.width_skala" [style.height.px]="slup.height_skala" [cdkDragDisabled] = "CzyDisabled(i)"  [cdkDragFreeDragPosition]="slup.dragPosition" (dblclick) = "otworzSlup(s)" (cdkDragStarted)="onDragStart($event, slup, s)"  (cdkDragEnded)="onDragEnd($event, slup, s)">
                                        
                                        <div *ngIf = "slup.stopa != ''" class="stopa stopa_{{slup.stopa}} strona_{{slup.jakaStrona(control.pergola)}}"><img class="slupx{{slup.stopa}}"  src="{{server_url}}//api/ActiveForm/GetIcon{{slup.stopa}}MultiNames?code={{system}}_UkładStopy_{{slup.stopa}}"></div>
                                        <div *ngIf = "slup.jest_dokladka" class="stopa_dokladka slup_dok_{{slup.jakaStrona(control.pergola)}}"><img  src="{{server_url}}//api/ActiveForm/GetIcon?code=Pergola_Dokładka_Słupa_Stopa"></div>
                                        <div class="wysokosc_slupa wys_strona_{{slup.jakaStrona(control.pergola)}}  wys_numer_{{s}}">
                                            <ng-container *ngIf = "slup.czyinnawys">
                                                h={{slup.innawysokosc}}<span id="mm" [translation]="TranslationEnum.Translation">{{'mm'|translate}}</span>
                                            </ng-container>
                                            <ng-container *ngIf = "!slup.czyinnawys">
                                                h={{control.pergola.wysokosc}}<span id="mm" [translation]="TranslationEnum.Translation">{{'mm'|translate}}</span>
                                            </ng-container>
                                        </div>
                                        
                                        <div *ngIf = "!slup.przenosze && slup.pozy != 0  && slup.jakaStrona(control.pergola) == 1" class="wymiar1"  [style.height.px]="slup.wymiar_y * slup.skala + 1"  [style.bottom.px]="slup.getHeight() - 2">
                                            <div class= "wymiar_liniax"></div>
                                            <div class= "wymiar_wew">{{slup.wymiar_y}} mm </div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy != 0 && slup.jakaStrona(control.pergola) == 3" class="wymiar3"  [style.height.px]="slup.wymiar_y * slup.skala + 1"  [style.bottom.px]="slup.getHeight() - 2">
                                            <div class= "wymiar_liniax3"></div>
                                            <div class= "wymiar_wew3">{{slup.wymiar_y}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy == 0 && slup.jakaStrona(control.pergola) == 3"  class="wymiar2"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax2"></div>
                                            <div class= "wymiar_wew2">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.jakaStrona(control.pergola) == 2" class="wymiar2"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax2"></div>
                                            <div class= "wymiar_wew2">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.jakaStrona(control.pergola) == 4" class="wymiar4"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax4"></div>
                                            <div class= "wymiar_wew4">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy == control.pergola.glebokosc - control.pergola.szerokosc_slupa && slup.jakaStrona(control.pergola) == 3" class="wymiar4"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax4"></div>
                                            <div class= "wymiar_wew4">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div class="error_stopa" (click) = "otworzSlup(s)" *ngIf = "slup.rodzaj == 'SLUP' && (((slup.stopa == null || slup.stopa.trim() == '')  && control.pergola.brakStop != 'TAK') || slup.blad || slup.blad_nachodzi || slup.bladWysokosc || slup.bladBlokada)">
                                            <div class="cypelek" ></div>
                                            <div id="uzupelnij_stope"  *ngIf = "slup.rodzaj == 'SLUP' && (slup.stopa == null || slup.stopa.trim() == '') && control.pergola.brakStop != 'TAK'" [translation]="TranslationEnum.Translation">{{'uzupelnij_stope'|translate}}</div>
                                            <div id="błędnie_postawiony"  *ngIf = "slup.rodzaj == 'SLUP' && (slup.blad || slup.blad_nachodzi)" [translation]="TranslationEnum.Translation">{{'błędnie_postawiony'|translate}}</div>
                                            <div id="bledna_wysokosc"  *ngIf = "slup.rodzaj == 'SLUP' && (slup.bladWysokosc)" [translation]="TranslationEnum.Translation">{{'bledna_wysokosc'|translate}}</div>
                                            <div id="blad_zablokowana"  *ngIf = "slup.bladBlokada" [translation]="TranslationEnum.Translation">{{'blad_zablokowana'|translate}}</div>
                                            
                                        </div>
                                    </div>
                                    <div class="slup blad_{{slup.blad || slup.blad_nachodzi || slup.bladWysokosc}}" *ngIf = "s < 4 && slup.czy_widoczny"   [style.width.px]="slup.width_skala" [style.height.px]="slup.height_skala"  [style.left.px]="slup.dragPosition.x" [style.top.px]="slup.dragPosition.y"  (dblclick) = "otworzSlup(s)">
                                        <div *ngIf = "slup.stopa != ''" class="stopa stopa_{{slup.stopa}}"><img  src="{{server_url}}//api/ActiveForm/GetIcon{{slup.stopa}}MultiNames?code={{system}}_UkładStopy_{{slup.stopa}}"></div>
                                        <div *ngIf = "slup.jest_dokladka" class="stopa_dokladka slup_dok_{{slup.jakaStrona(control.pergola)}}"><img  src="{{server_url}}//api/ActiveForm/GetIcon?code=Pergola_Dokładka_Słupa_Stopa"></div>
                                        <div class="wysokosc_slupa wys_strona_{{slup.jakaStrona(control.pergola)}}  wys_numer_{{s}}" *ngIf = "true || slup.czyinnawys">
                                           <ng-container *ngIf = "slup.czyinnawys">
                                                h={{slup.innawysokosc}}<span id="mm" [translation]="TranslationEnum.Translation">{{'mm'|translate}}</span>
                                            </ng-container>
                                            <ng-container *ngIf = "!slup.czyinnawys">
                                                h={{control.pergola.wysokosc}}<span id="mm" [translation]="TranslationEnum.Translation">{{'mm'|translate}}</span>
                                            </ng-container>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy != 0  && slup.jakaStrona(control.pergola) == 1" class="wymiar1"  [style.height.px]="slup.wymiar_y * slup.skala + 1"  [style.bottom.px]="slup.getHeight() - 2">
                                            <div class= "wymiar_liniax"></div>
                                            <div class= "wymiar_wew">{{slup.wymiar_y}} mm </div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy != 0 && slup.jakaStrona(control.pergola) == 3" class="wymiar3"  [style.height.px]="slup.wymiar_y * slup.skala + 1"  [style.bottom.px]="slup.getHeight() - 2">
                                            <div class= "wymiar_liniax3"></div>
                                            <div class= "wymiar_wew3">{{slup.wymiar_y}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy == 0 && slup.jakaStrona(control.pergola) == 3"  class="wymiar2"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidthPlusDok() - 2">
                                            <div class= "wymiar_liniax2"></div>
                                            <div class= "wymiar_wew2">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.jakaStrona(control.pergola) == 2" class="wymiar2"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax2"></div>
                                            <div class= "wymiar_wew2">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.jakaStrona(control.pergola) == 4" class="wymiar4"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidth() - 2">
                                            <div class= "wymiar_liniax4"></div>
                                            <div class= "wymiar_wew4">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div *ngIf = "!slup.przenosze && slup.pozy == control.pergola.glebokosc - control.pergola.szerokosc_slupa && slup.jakaStrona(control.pergola) == 3" class="wymiar4"  [style.width.px]="slup.wymiar_x * slup.skala + 1"  [style.right.px]="slup.getWidthPlusDok() - 2">
                                            <div class= "wymiar_liniax4"></div>
                                            <div class= "wymiar_wew4">{{slup.wymiar_x}} mm</div>
                                        </div>
                                        <div class="error_stopa" (click) = "otworzSlup(s)" *ngIf = "slup.rodzaj == 'SLUP' && ((((slup.stopa == null || slup.stopa.trim() == '') || slup.blad_stopy)  && control.pergola.brakStop != 'TAK') || slup.bladWysokosc)">
                                            <div class="cypelek" ></div>
                                            <div id="uzupelnij_stope"  *ngIf = "slup.rodzaj == 'SLUP' && (slup.stopa == null || slup.stopa.trim() == '' || slup.blad_stopy)  && control.pergola.brakStop != 'TAK'" [translation]="TranslationEnum.Translation">{{'uzupelnij_stope'|translate}}</div>
                                            
                                            <div id="bledna_wysokosc"  *ngIf = "slup.rodzaj == 'SLUP' && (slup.bladWysokosc)" [translation]="TranslationEnum.Translation">{{'bledna_wysokosc'|translate}}</div>
                                        </div>
                                    </div>
                                    <div class="slup slup_usuniety" *ngIf = "!slup.czy_widoczny"   [style.width.px]="slup.width_skala" [style.height.px]="slup.height_skala"  [style.left.px]="slup.dragPosition.x" [style.top.px]="slup.dragPosition.y"  (dblclick) = "otworzSlup(s)">
                                        
                                    </div>
                                </ng-container>
                                
                            </div>
                            <div class="pole_wneki" *ngIf = "control.pergola.pergolaDodatki == 'TAK'">
                                <ng-container *ngFor="let wneka of control.pergola.Wneki; let w = index;">
                                    <div class="wneka wneka_{{wneka.sciana}} wneka_zaz_{{wneka.checked}}" *ngIf = "!(wneka.sciana == 'A' && control.pergola.blokadaA) && !(wneka.sciana == 'B' && control.pergola.blokadaB) && !(wneka.sciana == 'C' && control.pergola.blokadaC) && !(wneka.sciana == 'D' && control.pergola.blokadaD)" [style.height.px]="wneka.wysokosc_w_px" [style.width.px]="wneka.szerokosc_w_px" [style.left.px]="wneka.pozx" [style.top.px]="wneka.pozy">
                                        <div class="wneka_tresc">
                                            <div class="wneka_tresc_center">
                                                <div id = "wneka_txt"  [translation]="TranslationEnum.TranslationForm">{{'wneka_txt'|translate}}</div>
                                                <div class="checkbox_wneka">
                                                    <input type = "checkbox" [(ngModel)]="wneka.checked" (change) = "changeCheckWneka($event, w)" [disabled] = "CzyDisabled(i)">
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="wneka_tresc_numer" *ngIf = "wneka.numer != 0">
                                            <div class="wneka_tresc_center_numer">
                                                <div id = "wneka_txt_numer" >{{wneka.numer}}</div>
                                            </div>
                                            
                                        </div>
                                        
                                        <div class="wneka_icon"></div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="pergola_wew"   [style.left.px]="control.pergola.getColumnHeight()"   [style.top.px]="control.pergola.getColumnHeight()" [style.width.px]="control.pergola.getInnerWidth()"   [style.height.px]="control.pergola.getInnerHeight()">
                                
                            </div>
                            <div class="blokady">
                                <div class="blokada blokadaA" *ngIf = "control.pergola.blokadaA"  [style.height.px]="control.pergola.getColumnHeight()"></div>
                                <div class="blokada blokadaB" *ngIf = "control.pergola.blokadaB"  [style.width.px]="control.pergola.getColumnHeight()"></div>
                                <div class="blokada blokadaC" *ngIf = "control.pergola.blokadaC"  [style.height.px]="control.pergola.getColumnHeight()"></div>
                                <div class="blokada blokadaD" *ngIf = "control.pergola.blokadaD"  [style.width.px]="control.pergola.getColumnHeight()"></div>
                            </div>
                        </div>
                       
                    </div>
                        
                        
        
                        
                      
                </div>

                <div class="legenda legenda_{{control.pergola.getWidth() > 520}}">
                    <h2 id = "legenda"  [translation]="TranslationEnum.TranslationForm">{{'legenda'|translate}}</h2>
                    <div class ="legenda_hover">
                        <div class="opcja" ><div class="opcja_icon"><div class="slup_w"></div></div><div class="opcja_opis">- 
                            <span id = "slup"  [translation]="TranslationEnum.TranslationForm">{{'slup'|translate}}</span>
                            <button  mat-flat-button  type="button" color="accent" id="dodaj_slup" class="btn-sm float-right"
                            [translation]="TranslationEnum.TranslationForm" (click) = "dodajSlup()">
                            {{'dodaj_slup'|translate}}
                            </button>
                    
                        </div></div>
                    

                        <div class="opcja"><div class="opcja_icon"><div class="slup_w blad_true"></div></div><div class="opcja_opis">- <span id = "blad_slup"  [translation]="TranslationEnum.TranslationForm">{{'blad_slup'|translate}}</span></div></div>
                        <div class="opcja"><div class="opcja_icon"><div class="slup_w slup_usuniety"></div></div><div class="opcja_opis">- <span id = "slupusuniety"  [translation]="TranslationEnum.TranslationForm">{{'slupusuniety'|translate}}</span></div></div>
                        
                        <div class="opcja"><div class="opcja_icon"><div class="sciana_icon"></div></div><div class="opcja_opis">- <span id = "sciana_text"  [translation]="TranslationEnum.TranslationForm">{{'sciana_text'|translate}}</span></div></div>
                        <div class="opcja"><div class="opcja_icon"><div class="pergola_icon"></div></div><div class="opcja_opis">- <span id = "pergola_obok_text"  [translation]="TranslationEnum.TranslationForm">{{'pergola_obok_text'|translate}}</span></div></div>
                        <div class="opcja"><div class="opcja_icon"><div class="blokada_icon2"><div class="blokada_icon"></div></div></div><div class="opcja_opis">- <span id = "blokada_text"  [translation]="TranslationEnum.TranslationForm">{{'blokada_text'|translate}}</span></div></div>
                        


                        <div *ngIf = "false && control.src">
                           
                                <img [src]="control.src"  [style.width.px]="control.PictureWidth">
                        </div>
                        <div class = 'skala'>
                            <div id = "ustaw_skale"  [translation]="TranslationEnum.TranslationForm">{{'ustaw_skale'|translate}}</div>
                            <div class = "skalaplus" (click) = "skalaPlus()"></div><div class = "skalaminus" (click) = "skalaMinus()"></div>
                        </div>
                        
                        <div id="podpowiedz" [translation]="TranslationEnum.TranslationForm">
                            {{'podpowiedz'|translate}}
                        </div>

                        
                        <div class="opcja2" >
                            <div *ngIf = "control.pergola.file_aktualny" id="wygenerowany_plik" [translation]="TranslationEnum.TranslationForm">
                                {{'wygenerowany_plik'|translate}}
                            </div>
                            <div *ngIf = "!control.pergola.file_aktualny" id="potrzebne_generowanie_pliku" [translation]="TranslationEnum.TranslationForm">
                                {{'potrzebne_generowanie_pliku'|translate}}
                            </div>
                            <div class="box_gen" *ngIf = "false">
                                <div class="pole_icon icon_{{control.pergola.file_aktualny}}">

                                </div>
                                <div class="box_button box_b_icon_{{control.pergola.file_aktualny}}">
                                    <button  mat-flat-button  type="button" color="accent" id="print_img_to_jpg" class="btn-sm float-right"
                                    [translation]="TranslationEnum.TranslationForm" (click) = "generateImage()" *ngIf = "true">
                                    {{'print_img_to_jpg'|translate}}
                                    </button>
                                </div>
                            </div>
                               
                    
                        </div>

                    </div>
                    
                </div>

            </div>
            
          
    </ng-container>

            
    
            
            <ng-container *ngSwitchCase="'Text'"><div class="Text FitScale poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
               
                <div class="kon" >
                    <input class ="Akapit_Info Akapit_{{control.Akapit}}"  name="parametr" (change) = "changeText(control)" [disabled] = "CzyDisabled(i)"  [style.font-size.px]="control.Size"  [(ngModel)]="control.wybrany.Value"  [style.background-color]="control.BackgroundColour" [style.color]="control.ForegrandColour" >
                </div>
                        
                 
            </div></ng-container>
    
    
             
            <ng-container *ngSwitchCase="'Number'"><div class="Number poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span> ({{getMinNumber()}} - {{getMaxNumber()}})
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon">
                    <input  name="parametr" (change) = "changeNumber(control)" [disabled] = "CzyDisabled(i)"  [style.font-size.px]="control.Size"  [(ngModel)]="control.wybrany.Value">
                </div>
                        
                 
            </div></ng-container>
    
    
            <ng-container *ngSwitchCase="'VarianticVisualization'"><div class="VarianticVisualization poprawna{{control.poprawne}}">
                
            </div></ng-container>
            
            <ng-container *ngSwitchCase="'Render'"><div class="Render poprawna{{control.poprawne}} formatuj">
                
                <div class="kon" (click) = "zmienionoParametr()">
                    <img [src]="control.src"  [style.width.px]="control.PictureWidth">
                </div>
                        
                 
            </div></ng-container>
            
            
            
            <ng-container *ngSwitchCase="'CheckNumber'"><div class="CheckNumber poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span> ({{getMinNumber()}} - {{getMaxNumber()}})
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                
                        
                 
                        <div class="CheckSelect_box kon">
                            <div class="CheckSelect_check">
                                <input type = "checkbox"  [style.font-size.px]="control.Size"  [(ngModel)]="checked" (change) = "changeCheckNumber($event)" [disabled] = "CzyDisabled(i)">
                            </div>
                            <div class="CheckSelect_selkect">
                                <input  name="parametr"  [style.font-size.px]="control.Size"  (change) = "changeNumber(control)" [disabled] = "CzyDisabled(i) && checked" [(ngModel)]="control.wybrany.Value">
                            </div>
                        </div>
            </div></ng-container>
    
            <ng-container *ngSwitchCase="'CheckSelect'"><div class="CheckSelect poprawna{{control.poprawne}} czyaktywny{{czyAktywnyCheckSelect()}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="CheckSelect_box con">
                    <div class="CheckSelect_check">
                        <input type = "checkbox" [(ngModel)]="checked" (change) = "changeCheckSelect($event)" [disabled] = "CzyDisabled(i)">
                    </div>
                    <div class="CheckSelect_selkect">
                        <form [formGroup]="form">
                            <mat-form-field  [style.font-size.px]="control.Size">
                                <mat-select (selectionChange) = "changeSelect($event)" formControlName="state"  [style.font-size.px]="control.Size">
                                    <ng-container  *ngFor="let v of control.Values; let kk = index;">
                                        <mat-option [value]="v.Key">{{v.DisplayValue}}</mat-option>
                                    </ng-container>
                                  
                                </mat-select>
                              </mat-form-field>
                        </form>
                    </div>
                </div>
                
               
                
                
            </div></ng-container>

            <ng-container *ngSwitchCase="'CheckSelectMultiColumn'"><div class="CheckSelect poprawna{{control.poprawne}} czyaktywny{{czyAktywnyCheckSelect()}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="CheckSelect_box con">
                    <div class="CheckSelect_check">
                        <input type = "checkbox" [(ngModel)]="checked" (change) = "changeCheckSelectMulti($event)" [disabled] = "CzyDisabled(i)"  [style.font-size.px]="control.Size">
                    </div>
                    
                <div class="pole_wartosc_kim2" (click) = "otworzSelectMultiColumnCheck()"><span class="kolor"  *ngIf = "checked && control.wybrany.Kolor != null && control.wybrany.Kolor != ''" [style.background-color]="control.wybrany.Kolor" [style.font-size.px]="control.Size" ></span>{{control.wybrany.DisplayValue}}</div>
            
                </div>
                
               
                
                
            </div></ng-container>


            
            <ng-container *ngSwitchCase="'Select'"><div class="Select FitScale poprawna{{control.poprawne}} czyaktywny{{czyAktywnySelect()}} formatuj">
                <span class="Label_box ng">
                    <span id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon"  class = "Akapit_Info Akapit_{{control.Akapit}}"  >
                    <form [formGroup]="form" [style.background-color]="control.BackgroundColour">
                        <mat-form-field [style.font-size.px]="control.Size">
                            <mat-select (selectionChange) = "changeSelect($event)" formControlName="state" width = "auto" [style.font-size.px]="control.Size"   [style.color]="control.ForegrandColour">
                                <ng-container  *ngFor="let v of control.Values; let kk = index;">
                                    <mat-option [value]="v.Key"><span  [style.color]="control.ForegrandColour"  class = "Akapit_txt Akapit_{{control.Akapit}}">{{v.DisplayValue}}</span></mat-option>
                                </ng-container>
                            
                            </mat-select>
                        </mat-form-field>
                    </form>
                </div>
                
                
            </div></ng-container>
            
            <ng-container *ngSwitchCase="'Radio'"><div class="Radio poprawna{{control.poprawne}} czyaktywny{{czyAktywnyRadio()}} formatuj">
                <span class="Label_box ng">
                    <span id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon" [style.background-color]="control.BackgroundColour">
                    
                            <mat-radio-group (change) = "changeSelect($event)" width = "auto"   [disabled] = "CzyDisabled(i)" [(ngModel)]="control.selectedOption">
                                <ng-container  *ngFor="let v of control.Values; let kk = index;" >
                                    <mat-radio-button [value]="v.Key" ><span  [style.font-size.px]="control.Size" [style.color]="control.ForegrandColour" >{{v.DisplayValue}}</span></mat-radio-button>
                                </ng-container>
                            
                            </mat-radio-group>
                    
                </div>
                
                
            </div></ng-container>
            <ng-container *ngSwitchCase="'RadioImg'"><div class="RadioImg poprawna{{control.poprawne}} formatuj">
                <span class="Label_box">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon">
                    <div class="fotobox fotobox_{{control.Width}}">
                        <ng-container *ngFor="let v of control.Values; let kk = index;">
                            <span class="foto_control zaznaczony_{{v.Key == control.wybrany.Value}} Disabled_{{v.Disabled}}"  (click) = "zmienWartosc(v.Key, v.Disabled)">
                                <div class="ok"></div>
                                <img class="foto"  src="{{server_url}}//api/ActiveForm/GetIcon?code={{system}}_{{control.KeyName}}_{{v.Key}}" [style.width.px]="control.PictureWidth">
                                <div class="wartosc"  [style.font-size.px]="control.Size">{{v.DisplayValue}}</div>
                            </span>
                        </ng-container>
                    </div>
                </div>
                
            </div></ng-container>
            
            <ng-container *ngSwitchCase="'Pdf'"><div class="Pdf poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon">
                    <a href="{{control.DefaultValue}}" target = "_blank"><div class="Pdf_tlo" [style.width.px]="control.PictureWidth" [style.height.px]="control.PictureWidth"></div></a>
                </div>
                
            </div></ng-container>
         
            <ng-container *ngSwitchCase="'SelectImg'"><div class="SelectImg poprawna{{control.poprawne}} czyaktywny{{czyAktywnySelect()}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="kon">
                    <form [formGroup]="form">
                        <mat-form-field  [style.font-size.px]="control.Size">
                            <mat-select (selectionChange) = "changeSelect($event)" formControlName="state"  [style.font-size.px]="control.Size">
                                <ng-container  *ngFor="let v of control.Values; let kk = index;">
                                    <mat-option [value]="v.Key"><div class="select_wybor"><img class="foto"  src="{{server_url}}//api/ActiveForm/GetIcon?code={{v.Key}}" [style.width.px]="control.PictureWidth"><sapn class="select_text">{{v.DisplayValue}}</sapn></div></mat-option>
                                </ng-container>
                            
                            </mat-select>
                        </mat-form-field>
                    </form>
                </div>
                
                
            </div></ng-container>
    
            
            <ng-container *ngSwitchCase="'Img'"><div class="Img poprawna{{control.poprawne}}">
                <ng-container *ngIf ="control.KeyName.includes('Rysunek')">
                    <img class="foto" src="{{server_url}}//api/ActiveForm/GetIcon?code={{control.DefaultValue}}"  [style.width.px]="control.PictureWidth" >
                </ng-container>
                <ng-container *ngIf ="!control.KeyName.includes('Rysunek')">
                    <button [disabled]="CzyDisabled(i)" mat-flat-button  type="button" color="accent"  [style.background-color]="control.BackgroundColour" id="label_{{control.TranslateCode.toLowerCase()}}"   [style.color]="control.ForegrandColour"   class="btn-sm float-right Akapit_img AkapitIMG_{{control.Akapit}}"
                    [translation]="TranslationEnum.TranslationForm" (click)="openImgDialog()"  [style.font-size.px]="control.Size">
                    {{('label_'+ control.TranslateCode.toLowerCase())|translate}}
                  </button>
             
                    
                    <ng-template #imgDialog>
                    <div mat-dialog-content>
                        <img [src]="control.src">
                    </div>
                    </ng-template>
                </ng-container>
                  
            </div></ng-container>
            
            <ng-container *ngSwitchCase="'Kim'"><div class="Kim poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="pole_wartosc_kim kon" (click) = "otworzKim()">{{control.wybrany.Value}}</div>
            </div></ng-container>

            
            <ng-container *ngSwitchCase="'SelectMultiColumn'"><div class="SelectMultiColumn poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="pole_wartosc_kim kon" (click) = "otworzSelectMultiColumn()"><span class="kolor"  *ngIf = "control.wybrany.Kolor != null && control.wybrany.Kolor != ''" [style.background-color]="control.wybrany.Kolor" [style.font-size.px]="control.Size" ></span>{{control.wybrany.DisplayValue}}</div>
            </div></ng-container>
            <ng-container *ngSwitchCase="'Fabric'"><div class="Fabric poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="pole_wartosc_kim kon" (click) = "otworzFabric()"><img *ngIf = "control.wybrany.Value != null && control.wybrany.Value != ''" src = "{{server_url}}//api/ActiveForm/GetIcon?code={{control.wybrany.Value}}" /> {{control.wybrany.DisplayValue}}</div>
            </div></ng-container>
            <ng-container *ngSwitchCase="'WyborParent'"><div class="WyborParent poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="pole_wartosc_kim kon" (click) = "otworzParent()"  [style.font-size.px]="control.Size">{{control.wybrany.DisplayValue}}</div>
            </div></ng-container>
            <ng-container *ngSwitchCase="'WyborParentModule'">
                <div *ngIf = "this.moduleList.length > 1" class="WyborParentModule poprawna{{control.poprawne}} formatuj">
                    <span class="Label_box ng">
                        <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                        <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                    </span>
                    <div class="pole_wartosc_kim kon" (click) = "otworzParentMod()"  [style.font-size.px]="control.Size">{{control.wybrany.DisplayValue}}</div>
                </div>
                <div *ngIf = "this.moduleList.length == 1" class="WyborParentModule poprawna{{control.poprawne}} formatuj">
                    <span class="Label_box ng">
                        <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                        <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                    </span>
                    <div class="pole_wartosc_kim kon"  [style.font-size.px]="control.Size">{{control.wybrany.DisplayValue}}</div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'WyborParentPosition'"><div class="WyborParentPosition poprawna{{control.poprawne}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="pole_wartosc_kim kon"  [style.font-size.px]="control.Size" (click) = "otworzParentPoz()">{{control.wybrany.DisplayValue}}</div>
            </div></ng-container>
            <ng-container *ngSwitchCase="'File'"><div class="File poprawna{{control.poprawne}} czyaktywny_{{CzyAktywny(i)}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
                <div class="file_box kon">
                    
                    <div class="pole_wartosc_kim">
                        <input  [style.font-size.px]="control.Size" [disabled] = "CzyDisabled(i)"
                #input
                type="file"
                (change)="changeImg($event)"
                accept="image/png, image/jpeg, image/gif, image/bmp, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain"
              />
                        {{control.wybrany.DisplayValue}} <div class="icon_upload"><mat-icon>file_upload</mat-icon></div></div><div *ngIf = "checked && fileExist()" class="file_view" (click) = "previewFile();"><mat-icon>remove_red_eye</mat-icon></div></div>
                
            </div></ng-container>
            <ng-container *ngSwitchCase="'CheckFile'"><div class="CheckFile poprawna{{control.poprawne}} czyaktywny_{{CzyAktywny(i) && checked}} formatuj">
                <span class="Label_box ng">
                    <span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                    <app-information [label]="control.TranslateCode" [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                </span>
    
                <div class="CheckSelect_box kon">
                    <div class="CheckSelect_check">
                        <input type = "checkbox" [(ngModel)]="checked" (change) = "changeCheckFile($event)" [disabled] = "CzyDisabled(i)">
                    </div>
                    <div class="CheckSelect_selkect">
                        <div class="file_box">
                            <div class="pole_wartosc_kim">
                                <input  [disabled] = "CzyDisabled(i) && checked"
                #input
                type="file"
                (change)="changeImg($event)"
                accept="image/png, image/jpeg, image/gif, image/bmp, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain"
              />
                                {{control.wybrany.DisplayValue}} <div class="icon_upload"><mat-icon>file_upload</mat-icon></div></div><div *ngIf = "checked && fileExist()" class="file_view" (click) = "previewFile();"><mat-icon>remove_red_eye</mat-icon></div></div>
                    </div>
                </div>
    
                
                
            </div></ng-container>
            <ng-container *ngSwitchDefault>
                <div class="kontrolki poprawna{{control.poprawne}} formatuj">
                    <span class="Label_box ng">
                        <span *ngIf = "control.ControlType != 'Hidden'">UWAGA - Kontrolka ({{control.ControlType}}) nie zaimplementowana, proszę zgłosić do działu wsparcia! - </span><span  id="label_{{control.TranslateCode.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{('label_' + control.TranslateCode.toLowerCase())|translate}}</span>
                        <app-information [label]="control.TranslateCode"  [notAffectOnOtherControl]='control.notAffectToOtherControls' [fileInfoId]="fileInfoId"></app-information>
                    </span>
                    <div class="pole_wartosc kon"><input name="parametr" (change) = "FormData.ZmianaParametru(control)" [disabled] = "CzyDisabled(i)" [(ngModel)]="control.wybrany.Value" /></div>
        
                </div>
            </ng-container>
        </container-element>
       
    </ng-container>
        
    

</div>
   
    
